module.exports = __webpack_public_path__ + "static/media/ea_init.50b68b15.png";